import { Mail, Phone, ExternalLink } from "lucide-react";
import { PageMeta } from "../components/PageMeta";
import { PageHero } from "../components/PageHero";
import { FloatingDots } from "../components/heroes/FloatingDots";
import { Reveal } from "../components/Reveal";
import { InquiryStepper } from "../components/InquiryStepper";
import { ReviewBadge } from "../components/ReviewBadge";
import { GoldTrophy } from "../components/GoldTrophy";
import { CONTACT, FAQS } from "../data/content";
import { Pic } from "../components/Pic";
import { Faq } from "../components/Faq";
import { Link } from "react-router-dom";

export default function Contact() {
  return (
    <>
      <PageMeta title="Plan Your Event" description="Tell Entertainment Nation about your event and we'll take it from there. Email info@bookentertainmentnation.com or call 904-403-6575." />
      <PageHero testId="contact-hero" variant="contact" eyebrow="Let's connect" titleFx="underline" title="We make it easy. Your vision, our expertise." intro="No matter where you are in the planning process, we're here to help make your event a hit. From big ideas to small details, we've got you covered." topBand={<FloatingDots />} />

      <section className="bg-white pb-24 pt-4 lg:pb-32" data-testid="contact-section">
        <div className="mx-auto grid max-w-7xl gap-12 px-5 sm:px-8 lg:grid-cols-12">
          <Reveal className="lg:col-span-4">
            <div className="card-white p-7 sm:p-8">
              <p className="eyebrow mb-5">Contact details</p>
              <ul className="chip-stagger space-y-5">
                <li>
                  <p className="font-gothic uppercase tracking-wider text-xs text-black/50">Email</p>
                  <a href={`mailto:${CONTACT.email}`} data-testid="contact-email-link" data-track="email_click" className="mt-1 flex items-center gap-2 text-base text-black hover:text-en-teal break-all"><Mail className="h-4 w-4 shrink-0 text-en-teal" />{CONTACT.email}</a>
                </li>
                <li>
                  <p className="font-gothic uppercase tracking-wider text-xs text-black/50">Phone</p>
                  <a href={CONTACT.phoneHref} data-testid="contact-phone-link" data-track="phone_click" className="mt-1 flex items-center gap-2 text-base text-black hover:text-en-teal"><Phone className="h-4 w-4 shrink-0 text-en-teal" />{CONTACT.phone}</a>
                </li>
                <li>
                  <p className="font-gothic uppercase tracking-wider text-xs text-black/50">Powered by</p>
                  <a href={CONTACT.triviaNation} target="_blank" rel="noreferrer" data-testid="contact-trivia-nation-link" className="mt-1 flex items-center gap-2 text-base text-black hover:text-en-teal"><ExternalLink className="h-4 w-4 shrink-0 text-en-teal" />Trivia Nation</a>
                </li>
              </ul>
              <Pic src="/images/blob-2.png" alt="Winning team pointing at the trophy after a Trivia Nation game show" sizes="(min-width: 1024px) 30vw, 100vw" className="mt-8 w-full" />
              <ReviewBadge testId="contact-review-badge" className="mt-6" />
            </div>
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-8">
            <div className="gradient-frame card-enter rounded-2xl p-[2px]" data-testid="contact-form-card">
            <div className="card-white p-6 sm:p-10">
              <h2 className="font-display flex items-center gap-3 text-2xl sm:text-3xl"><GoldTrophy className="h-7 w-7 shrink-0" data-testid="contact-form-trophy" /> Tell us about your event</h2>
              <p className="mt-2 text-sm text-black/60">We'll get the ball rolling and help you create something unforgettable. Not sure which format fits? <Link to="/experiences" data-testid="contact-experiences-link" className="link-teal">Compare our game packages</Link> first.</p>
              <div className="mt-8"><InquiryStepper /></div>
            </div>
            </div>
          </Reveal>
        </div>
      </section>
      <Faq items={FAQS.contact} title="Before you reach out." intro="What to expect once you send an inquiry." testId="contact-faq" />
    </>
  );
}
